import { Text, Modal, Button, Navigation, Cell } from '@vinted/web-ui';
import useTranslate from 'hooks/useTranslate';
import ScrollableArea from 'components/ScrollableArea';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const ClosetPromotionDynamicPricingInfoModal = _ref => {
  let {
    show,
    onBack
  } = _ref;
  const translate = useTranslate('closet_promotion.dynamic_pricing_info_modal');

  function renderInfoBlock(type) {
    return /*#__PURE__*/_jsx(Cell, {
      title: /*#__PURE__*/_jsx(Text, {
        text: translate("".concat(type, ".title")),
        type: Text.Type.Title
      }),
      body: /*#__PURE__*/_jsx(Text, {
        text: translate("".concat(type, ".body")),
        html: true
      })
    });
  }

  return /*#__PURE__*/_jsx(Modal, {
    show: show,
    hasScrollableContent: true,
    children: /*#__PURE__*/_jsx("div", {
      className: "u-fill-width",
      children: /*#__PURE__*/_jsxs(ScrollableArea, {
        children: [/*#__PURE__*/_jsx(Navigation, {
          left: /*#__PURE__*/_jsx(Button, {
            theme: "amplified",
            deprecatedIconName: "arrow-left",
            styling: Button.Styling.Flat,
            testId: "closet-promotion-dynamic-pricing-info-back-button",
            onClick: onBack
          }),
          body: /*#__PURE__*/_jsx(Text, {
            text: translate('title'),
            type: Text.Type.Title
          })
        }), renderInfoBlock('what'), renderInfoBlock('how')]
      })
    })
  });
};

export default ClosetPromotionDynamicPricingInfoModal;